export const experiments = {
  home_hero_redesign: {
    variants: ['control'],
    status: 'shipped',
    startedAt: '2026-05-01',
    notes: 'Treatment paused while iterating on control. Treatment code retained at variants/HomeTreatment.jsx for resurrection.',
  },
  home_hero_copy: {
    variants: ['control', 'treatment'],
    status: 'running',
    startedAt: '2026-09-15',
    notes: 'Hero copy + screenshot: current hero vs category/ICP-named hero from marketing audit.',
  },
};
